import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f4afb61&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4afb61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4afb61')) {
      api.createRecord('6f4afb61', component.options)
    } else {
      api.reload('6f4afb61', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f4afb61&scoped=true", function () {
      api.rerender('6f4afb61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/delivery/result/index.vue"
export default component.exports